import { Link } from "react-router-dom";
import Title from "../../Global/Title/Title";
import { HEADING_LEVELS, COMPATIBLEPRODUCTSTABID } from "../../Global/GlobalConstants";
import { getUrlPath } from "../../../helpers/LinkHelper";
import { scrollAndSetFocusOnPDP } from "../../../helpers/GlobalHelpers";

/**
 * Product heading section with family name, product name, code, and compatible products link
 */
const ProductHeading = ({
  productData,
  product,
  pfamLink,
  compatibleProductsLabel,
  productReaderPrefix,
  isMobileNav,
  scrollingTo,
  setAlertMessage,
}) => {
  if (!productData) {
    return null;
  }

  /**
   * Handle click on compatible products link
   */
  const handleCompatibleProductsClick = (tabId, tabName, isMobile) => {
    scrollAndSetFocusOnPDP(tabId, tabName, isMobile, `${scrollingTo} ${tabName}`, setAlertMessage);
  };

  return (
    <div className="pdp-header__heading">
      {productData?.collection && (
        <Link to={getUrlPath(pfamLink)} className="pdp-header__heading-product-family-name">
          {productData.collection ?? ""}
        </Link>
      )}
      {productData?.childProductName && (
        <Title defaultLevel={HEADING_LEVELS.ONE} className="pdp-header__heading-product-name">
          {productData.childProductName ?? ""}
        </Title>
      )}
      <div className="pdp-header__heading-info-line">
        <span className="pdp-header__heading-product-code">{product.productCode}</span>
        {productData?.compatibleProducts.length > 0 && (
          <>
            <span className="pdp-header__heading-product-code">&nbsp;-&nbsp;</span>
            <button
              type="button"
              aria-label={`${productReaderPrefix} ${productData.compatibleProducts.length} ${compatibleProductsLabel}`}
              className="pdp-header__heading-compatible-products"
              onClick={() =>
                handleCompatibleProductsClick(
                  COMPATIBLEPRODUCTSTABID,
                  compatibleProductsLabel,
                  isMobileNav
                )
              }
            >
              {productData.compatibleProducts.length} {compatibleProductsLabel}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ProductHeading;
